<script>
export default {
  name: "MenuItem",
  functional: true,
  props: {
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    popObj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  render(h, context) {
    const { icon, title, popObj} = context.props
    const vnodes = []

    if (icon) {
      if (icon.includes("el-icon")) {
        vnodes.push(<i class={[icon, "sub-el-icon"]} />)
      } else {
        vnodes.push(<svg-icon iconClass={icon}/>)
      }
    }

    if (title) {
      vnodes.push(<span slot='title' class="menu-title">{(title)}</span>)
    }

    if (popObj.popType === "point") {
      vnodes.push(<span class="sign"></span>)
    }
    if (popObj.popType === "num" && popObj.num !== 0) {
      vnodes.push(<span class="sign-num">{(popObj.num)}</span>)    
    }
    return vnodes
  }
}
</script>

<style lang="scss" scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
  font-size: 16px;
}
.menu-title{
  width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 12px;
}
</style>
